import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-choose-club" }
const _hoisted_2 = { class: "modal-choose-club_header header" }
const _hoisted_3 = { class: "modal-choose-club_row" }
const _hoisted_4 = { class: "header_title" }
const _hoisted_5 = { class: "modal-choose-club_body body" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "club_title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ac_modal = _resolveComponent("ac-modal")!

  return (_openBlock(), _createBlock(_component_ac_modal, {
    "model-value": _ctx.modelValue,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.close($event)))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "header_empty" }, null, -1)),
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('navigationPage')), 1),
            _createElementVNode("div", {
              class: "header_close",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close(false)))
            }, [...(_cache[2] || (_cache[2] = [
              _createElementVNode("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                _createElementVNode("g", { "clip-path": "url(#clip0_3513_9588)" }, [
                  _createElementVNode("path", {
                    d: "M12 10.586L16.243 6.34299C16.6335 5.95252 17.2665 5.95252 17.657 6.34299C18.0475 6.73345 18.0475 7.36652 17.657 7.75699L13.414 12L17.657 16.243C18.0475 16.6335 18.0475 17.2665 17.657 17.657C17.2665 18.0475 16.6335 18.0475 16.243 17.657L12 13.414L7.75699 17.657C7.36652 18.0475 6.73345 18.0475 6.34299 17.657C5.95252 17.2665 5.95252 16.6335 6.34299 16.243L10.586 12L6.34299 7.75699C5.95252 7.36652 5.95252 6.73345 6.34299 6.34299C6.73345 5.95252 7.36652 5.95252 7.75699 6.34299L12 10.586Z",
                    fill: "#0E2242"
                  })
                ]),
                _createElementVNode("defs", null, [
                  _createElementVNode("clipPath", { id: "clip0_3513_9588" }, [
                    _createElementVNode("rect", {
                      width: "24",
                      height: "24",
                      fill: "white"
                    })
                  ])
                ])
              ], -1)
            ]))])
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.communities, (club) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `club-${club.id}`,
              class: "club",
              onClick: ($event: any) => (_ctx.handlerChooseClub(club))
            }, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(club.title), 1)
            ], 8, _hoisted_6))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}